import { EditorView, ViewUpdate } from "@codemirror/view";
import { Extension } from "@codemirror/state";

type OnCursorChange = (cursorPosition: number, viewUpdate: ViewUpdate) => void;

export function onCursorUpdate(onCursorChange: OnCursorChange): Extension {
  return EditorView.updateListener.of((viewUpdate: ViewUpdate) => {
    const cursorPosition = viewUpdate.state.selection.main.head;
    onCursorChange(cursorPosition, viewUpdate);
  });
}
